export default __webpack_public_path__ + "images/6dce69e79da70929ea1ecbdfc54fa3eb.png";